/*
 *  File: search.service.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';

/**
 *
 * @author dlolugu1271
 * @description This is a service class which is used to invoke 
 * Subscription APIS and perform search and cancel within selfservice.
 * 
 */
@Injectable()
export class SearchService {

  private apiUrl: string = '';
  private appconfig = environment.appconfig;
  private appextconfig = environment.appextconfig;
  public tokenStr: any;
  public itemKey: string;
  public productId: string;
  public email: string;
  public cancelResp: any;
  private partner: string;
  public cancelDate: string = '';

  constructor(private http: HttpClient) { }
  
  /**
   *
   * @author dlolugu1271
   * @description This method searchOrder is used to invoke the 
   * subscription API searchCustomers for the given Item Key
   * and email Id combination.
   * @returns Observable<T>
   * 
   */
  public searchOrder<T>(): Observable<T> {
    const body = JSON.stringify({     
      "itemKey": this.itemKey,
      "productId": this.productId,
      "billingCustomer": {
        "email": this.email
      }
    });
    this.tokenStr = localStorage.getItem('token');
    let bearerToken = 'Bearer ' + this.tokenStr;
    let headers = new HttpHeaders({ 'Authorization': bearerToken });
    let options = { headers: headers };

    return this.http.post<T>(environment.appextconfig.subs_api_url + '/v2/selfServiceSearch', body, options);
  }

 /**
   *
   * @author dlolugu1271
   * @description This method retrieveDeliveryInfo is used to invoke the
   * subscription API retrieveAllInfo for the given partner order Id.
   * @param orderNo
   * @param partnerName
   * @param clientName
   * @param storeName
   * @returns Observable<T>
   * 
   */
  public retrieveDeliveryInfo<T>(
    orderNo: string,
    partnerName: string,
    clientName: string,
    storeName: string,
    configId: string): Observable<T> {
    const body = JSON.stringify({
      "retriveOrders": [{
        "configId": configId,
        "partnerName": partnerName,
        "clientName": clientName,
        "storeName": storeName,
        "partnerOrderNo": [orderNo]
      }],
      "history": false
    });
    this.tokenStr = localStorage.getItem('token');
    let bearerToken = 'Bearer ' + this.tokenStr;
    let headers = new HttpHeaders({ 'Authorization': bearerToken });
    let options = { headers: headers };

    return this.http.post<T>(environment.appextconfig.subs_api_url + '/v2/retrieveAll', body, options);
  }

  /**
   *
   * @author dlolugu1271
   * @description This method cancelOrder is used to invoke the
   * subscription API v2 cancel for the given Item key.
   * @param itemKey
   * @param orderNo
   * @param partnerName
   * @param clientName
   * @param storeName
   * @returns Observable<T>
   */
  public cancelOrder<T>(itemKey: string, orderNo: string,
    partnerName: string,
    clientName: string,
    storeName: string,
    configId: string) : Observable<T> {
    const body = JSON.stringify({
      "subscription": {
        "config": {
          "configId": configId,
          "partnerName": partnerName,
          "clientName": clientName,
          "storeName": storeName
        },
        "orderNo": orderNo,
        "productLineitems": [
          {
            "itemKey": itemKey,
            "statusCode": environment.appextconfig.client_details[storeName.toLowerCase()].cancel_status_cd,
            "activityStatus": environment.appconfig.status.cancel_active_status,
            "cancelReason": environment.appextconfig.client_details[storeName.toLowerCase()].cancel_reason
          }
        ]
      }
    });
    this.tokenStr = localStorage.getItem('token');
    let bearerToken = 'Bearer ' + this.tokenStr;
    let headers = new HttpHeaders({ 'Authorization': bearerToken });
    let options = { headers: headers };

    return this.http.put<T>(environment.appextconfig.subs_api_url + '/v2/cancel', body, options);
  }

}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/services/search.service.ts